<template>
  <div
    class="health-list-input"
    :class="{
      'is-danger': danger && filled,
      'is-invalid': state === false,
      'is-small': size === 'sm',
    }"
  >
    <multiselect
      :id="id"
      :value="items"
      :options="allOptions"
      :multiple="true"
      :taggable="true"
      :searchable="true"
      :close-on-select="false"
      :clear-on-select="true"
      :placeholder="placeholder"
      tag-placeholder="เพิ่มเป็นรายการใหม่ (Enter)"
      select-label=""
      selected-label="✓"
      deselect-label=""
      @input="onInput"
      @tag="onTag"
    >
      <template #noResult>ไม่พบรายการ</template>
    </multiselect>
    <div
      v-if="tooLong"
      class="error small-text"
    >
      *ข้อความยาวเกิน {{ maxlength }} ตัวอักษร
    </div>
  </div>
</template>

<script>
import {
  HEALTH_DENIED,
  toItems,
  fromItems,
  hasValue,
  pickItems,
  addTyped,
} from "@/utils/healthText";

export default {
  name: "HealthListInput",
  props: {
    value: { type: String, default: "" },
    options: { type: Array, default: () => [] },
    danger: { type: Boolean, default: false },
    placeholder: { type: String, default: "เลือกหรือพิมพ์…" },
    maxlength: { type: Number, default: 500 },
    state: { type: Boolean, default: null },
    size: { type: String, default: "" },
    id: { type: String, default: undefined },
  },
  data() {
    return { tooLong: false };
  },
  computed: {
    items() {
      return toItems(this.value);
    },
    allOptions() {
      const extra = this.items.filter(
        i => i !== HEALTH_DENIED && !this.options.includes(i)
      );
      return [HEALTH_DENIED, ...this.options, ...extra];
    },
    filled() {
      return hasValue(this.value);
    },
  },
  methods: {
    onInput(next) {
      this.commit(pickItems(this.items, next));
    },
    onTag(text) {
      this.commit(addTyped(this.items, text));
    },
    commit(items) {
      const text = fromItems(items);
      this.tooLong = text.length > this.maxlength;
      if (this.tooLong) return;
      this.$emit("input", text);
    },
  },
};
</script>

<style scoped>
.health-list-input.is-danger ::v-deep .multiselect__tags {
  border-color: #dc3545;
  background-color: #fff5f5;
}
.health-list-input.is-invalid ::v-deep .multiselect__tags {
  border-color: #dc3545;
}
.health-list-input.is-small ::v-deep .multiselect__tags {
  min-height: 31px;
  font-size: 0.875rem;
}
</style>
